export const filterItems = (items, values) => {
  let result = items;
  for (let value of values) {
    result = result.filter(({ uri }) => uri !== value);
  }
  return result;
};
